import site from "./site.json";
import categoriesData from "./categories.json";
import projectsData from "./projects.json";
import team from "./team.json";
import clients from "./clients.json";
import home from "./pages/home.json";
import about from "./pages/about.json";
import projectsPage from "./pages/projects.json";
import services from "./pages/services.json";
import contact from "./pages/contact.json";

const absoluteUrlPattern = /^(https?:)?\/\//;

export const publicUrl = (path) => {
  if (!path || absoluteUrlPattern.test(path)) return path;
  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const cleaned = path.replace(/^\//, "");
  return encodeURI(`${base}/${cleaned}`);
};

export { site, categoriesData, projectsData, team, clients, home, about, projectsPage, services, contact };
